
<div class="flex flex-col gap-2 h-full " [formGroup]="form()">
  @if (question().type === inputType.TEXT){

    @if (question().label) {
      <label class="font-semibold text-sm text-gray-900" [for]="question().key">{{ question().label }}</label>
    }
    <div [class]="question().width" [class.inputError]="(isError && question().errorText)" class="relative bg-gray-50 resize-none rounded-sm border cursor-pointer border-gray-300 hover:border-black *:border-solid overflow-hidden">
      @if (question().phoneMask) {
        <input 
          [class.inputError]="(isError && question().errorText)"
          class="w-full px-4 py-3 text-sm placeholder:text-sm text-gray-900 bg-gray-50 placeholder:text-gray-500 hover:bg-afcu-navy-50" 
          [formControlName]="question().key" 
          type="text" 
          afcuPhoneMask
          [id]="question().key" 
          (blur)="blurOut()"
          [tabIndex]="this.question().order"
          [placeholder]="question().placeholder">
      } @else {
        <input type="text" [name]="'fake-' + question().key" [autocomplete]="'auto'+question().key" style="display:none" aria-hidden="true" />

        <input 
          #searchQuery
          [tabIndex]="this.question().order"
          [class.fullWidth]="searchQueryType()"
          [class.inputError]="(isError && question().errorText)"
          class="w-full px-4 py-3 text-sm placeholder:text-sm text-gray-900 bg-gray-50 placeholder:text-gray-500 hover:bg-afcu-navy-50" 
          [formControlName]="question().key" 
          type="text" 
          [id]="question().key" 
          [placeholder]="question().placeholder"
          (blur)="blurOut()"
          (focus)="focus()"
          (input)="(!searchQueryType()) ? inputChange() : search(searchQuery.value)">

        @if(question().search) {
          @if(searchQuery.value.length > 0){
            <img id="clearSearch" class="absolute top-0 bottom-0 m-auto right-3" height="12" width="12" src="/icons/close.svg" (click)="resetSearch()">
          } @else {
            <img class="absolute top-0 bottom-0 m-auto right-3" height="20" width="20" src="/icons/search.svg">
          }
        }

      }
    </div>
  } @else if(question().type === inputType.CHECK) {

    <div class="flex gap-1.5">
      <div class="relative">
        <input
          class="peer h-4 w-4 cursor-pointer transition-all appearance-none rounded border border-slate-300 checked:bg-afcu-navy-800 checked:border-afcu-navy-800"
          [id]="question().key" 
          type="checkbox" 
          [formControlName]="question().key" 
          [tabIndex]="this.question().order"
          [value]="question().key"/>
          <span class="absolute text-white opacity-0 peer-checked:opacity-100 left-1/2 transform -translate-x-[50%] translate-y-[20%]" (click)="checkMe()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" stroke-width="1">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
            </svg>
          </span>
      </div>
      <div class="flex flex-col gap-0.5">
        <label [for]="question().key" class="text-sm flex font-semibold text-gray-900">{{question().label}}</label>
        <div class="text-gray-500 text-xs">{{question().helpText}}</div>
      </div>
    </div>
    
  } @else if (question().type === inputType.PASSWORD){

    <label class="font-semibold text-sm text-gray-900" [for]="question().key">{{ question().label }}</label>
    <div [class]="(isError ? 'bg-red-100 border-red-700 ' : 'bg-gray-50 border-gray-300 ') + ((question().width !== 'md:w-1/2 lg:w-1/2') ? 'w-[' + question().width + ']' : 'md:w-1/2 lg:w-1/2')" 
      class="relative text-sm text-gray-900 border rounded-sm flex items-center hover:border-black *:border-solid overflow-hidden focus:border-black focus:outline">
      <img  class="absolute right-4 w-4 h-4"  [src]="(!togglePassword) ? '/icons/eye-open.svg' : '/icons/eye-close.svg'" (click)="togglePassword = !togglePassword"/>
      @if (question().numberOnly){
        <input 
          [class]="(isError) ? 'placeholder:text-red-800' : 'text-gray-900 placeholder:text-gray-500'"
          class="w-full px-4 py-3 text-sm rounded-sm placeholder:text-sm hover:bg-afcu-navy-50 hover:border-black  hover:ring overflow-hidden"
          [formControlName]="question().key"
          [id]="question().key" 
          [type]="!togglePassword ? 'password' : 'text'" 
          [placeholder]="question().placeholder"
          (blur)="blurOut()"
          autocomplete="new-password"
          (input)="inputChange()"
          [tabIndex]="this.question().order"
          [maxlength]="(question().maxLength) ? question().maxLength : null"
          (keydown)="onKeyUpNumericOnly($event)">
      } @else {
        <input
          [class]="(isError) ? 'placeholder:text-red-800' : 'text-gray-900 placeholder:text-gray-500'"
          class="w-full text-sm rounded-sm placeholder:text-sm hover:bg-afcu-navy-50 "
          [formControlName]="question().key"
          [id]="question().key"
          autocomplete="off"
          [type]="!togglePassword ? 'new-password' : 'text'" 
          [placeholder]="question().placeholder"
          (blur)="blurOut()"
          (input)="inputChange()">
      }
     
    </div> 

  } @else if (question().type === inputType.AREA){
    
    <label class="font-semibold text-sm text-gray-900" [for]="question().key">{{ question().label }}</label>
    <textarea 
      [class]="question().width"
      class=" placeholder:text-gray-500 resize-none rounded-sm bg-gray-50 border border-gray-300 text-gray-900 px-4 py-3 h-28 text-sm hover:bg-afcu-navy-50 hover:border-black focus:outline" 
      [formControlName]="question().key"
      [id]="question().key" 
      [placeholder]="question().placeholder"
      (blur)="isValid"
      [tabIndex]="this.question().order"
      (change)="onChange($event)">
    </textarea>
  } @else if (question().type === inputType.DROPDOWN){
    @if(question().label){
      <label class="font-semibold text-sm text-gray-900" [for]="question().key">{{ question().label }}</label>
    }
    
    <select
      [id]="question().key"
      [class]="(isError) ? 'border-red-700 bg-red-100 text-red-800' : 'border-gray-300 text-gray-800 bg-gray-100'"
      class="border rounded-sm text-sm w-full h-full px-4 py-3 selected:border-afcu-navy-800 selected:bg-white selected:border-[3.5px] border-solid focus:border-gray-300 disabled:opacity-50" (change)="onChange($event)" [disabled]="question().disable">
      @for( option of question().options; track option.value){
        <option [value]="option.value" [selected]="option.selected">{{option.text}}</option>
      }
    </select>
  } @else if(question().type === inputType.RADIO) {
    <div class="flex gap-4">
      @for( option of question().options; track option.value; let idx = $index){
        <div class="flex gap-2 px-2 items-center">
          <input
          [tabIndex]="this.question().order + idx"
          type="radio" 
          id={{option.value}}
          value={{option.value}}
          [formControlName]="question().key"
          [name]="question().key" 
          class="w-4 h-4 appearance-none rounded-full checked:border-afcu-navy-800 checked:bg-white checked:border-4 bg-gray-150 border-[0.5px] border-gray-300 border-solid"
          (change)="onChange($event)">
          <label for={{option.value}} class="radio">
            <div class="md:w-1/6 w-full font-semibold text-gray-900 text-sm">{{option.text}}</div>
          </label>
        </div>
        
        <!-- <label for={{opt.code}} class="radio" [ngClass]="{'flex-col': addressTemplateRef}">
          <span *ngIf="question.key !== 'txn'" [ngClass]="{'flex gap-2 flex-col items-start lg:flex-row lg:items-center': iconTemplateRef}">
            <div class="md:w-1/6 w-full" *ngIf="opt.title">{{opt.title}}</div>
            <div [ngClass]="{'text-gray-500 text-sm font-normal w-full': opt.title}"  [innerHTML]="opt.text"></div>
            <ng-container1
              *ngIf="iconTemplateRef"
              [ngTemplateOutlet]="iconTemplateRef">
            </ng-container>
          </span>
          <ng-container
            *ngIf="addressTemplateRef"
            [ngTemplateOutlet]="addressTemplateRef"
            [ngTemplateOutletContext]="{$implicit:opt}">
          </ng-container>
          <ng-container
            [ngTemplateOutlet]="txnTemplateRef"
            [ngTemplateOutletContext]="{$implicit:opt}">
          </ng-container>
        </label> -->
        
      }    
    </div>
    
  }

  @if (question().errorText) {
    @if (!isValid && isError) {
      <div class="text-red-700 text-xs">{{ question().errorText }}</div>
    }
  }
</div>
